import React, { useState } from "react";
import { ArrowBigRight, Calendar, QrCode } from "lucide-react";
import { Link, useNavigate } from "react-router-dom";
import { QRCodeCanvas } from "qrcode.react";
import { AnimatePresence, motion } from "framer-motion";

const extractImageFromHTML = (html) => {
  const div = document.createElement("div");
  div.innerHTML = html;
  const img = div.querySelector("img");
  return img?.src || "/images/realty/default.jpg";
};

const extractDate = (iso) => {
  const date = new Date(iso);
  return date.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
};

// const handleDownloadQR = (posting_id) => {
//   const canvas = document.getElementById(`qr-${posting_id}`);
//   if (canvas) {
//     const pngUrl = canvas
//       .toDataURL("image/png")
//       .replace("image/png", "image/octet-stream");
//     const downloadLink = document.createElement("a");
//     downloadLink.href = pngUrl;
//     downloadLink.download = `QR_${posting_id}.png`;
//     document.body.appendChild(downloadLink);
//     downloadLink.click();
//     document.body.removeChild(downloadLink);
//   }
// };

const BlogCard = ({ post }) => {
  const navigate = useNavigate();
  const image = extractImageFromHTML(post.description);
  const date = extractDate(post.createdAt);

  // const [isQrModalOpen, setIsQrModalOpen] = useState(false);

  // const openQrModal = (e) => {
  //   e.stopPropagation(); // Prevent card navigation
  //   setIsQrModalOpen(true);
  // };

  // const closeQrModal = () => setIsQrModalOpen(false);

  return (
    <>
      <div
        onClick={() => {
          window.scrollTo({ top: 0, behavior: "smooth" });
          navigate(`/realty/blog/${post.posting_id}`);
        }}
        className="relative p-4 transform transition-all duration-300 border border-slate-800 rounded-3xl hover:border-gold cursor-pointer hover:shadow-gold"
      >
        <div className="block aspect-w-4 aspect-h-3 overflow-hidden rounded-xl">
          <img
            className="object-cover w-full h-48 hover:scale-110 transition-transform duration-400"
            src={post.images?.[0]?.url || image}
            alt={post.title}
          />
        </div>

        {/* Badge */}
        <div className="absolute top-6 left-6 capitalize bg-slate-800 animate-bounce text-white flex items-center gap-2 px-3 py-1 rounded-full text-sm font-bold">
          Blog
        </div>

        {/* Title with QR icon */}
        <div className="my-6 flex items-center justify-between">
          <p className="text-md font-semibold line-clamp-2 capitalize">
            {post.title}
          </p>
          {/* <p className="text-md font-semibold line-clamp-2">
            {post.title
              .toLowerCase()
              .replace(/\b\w/g, (char) => char.toUpperCase())}
          </p> */}

          {/* <div
            onClick={openQrModal}
            className="cursor-pointer p-1 rounded hover:bg-slate-700"
          >
            <QrCode className="w-6 h-6 text-gold" />
          </div> */}
        </div>

        {/* Footer */}
        <div className="flex items-center justify-between text-sm font-bold tracking-widest text-gray-500 uppercase">
          <div className="flex items-center gap-2">
            <Calendar size={16} className="text-gold" />
            {date}
          </div>
          <Link
            to={`/realty/blog/${post.posting_id}`}
            className="flex items-center gap-2 text-gold hover:underline transition"
          >
            Read more <ArrowBigRight size={15} />
          </Link>
        </div>
      </div>

      {/* QR Modal */}
      {/* <AnimatePresence>
        {isQrModalOpen && (
          <motion.div
            className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={closeQrModal}
          >
            <motion.div
              onClick={(e) => e.stopPropagation()}
              initial={{ scale: 0.8, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.8, opacity: 0 }}
              transition={{ duration: 0.3, ease: "easeInOut" }}
              className="relative flex flex-col gap-4 justify-center items-center bg-slate-900 rounded-2xl shadow-lg p-6 max-w-xs w-full text-center"
            >
              <button
                onClick={closeQrModal}
                className="absolute top-2 right-3 text-slate-400 hover:text-white text-3xl"
              >
                &times;
              </button>

              <QRCodeCanvas
                id={`qr-${post.posting_id}`}
                value={`https://scanglobal-website.web.app/realty/blog/${post.posting_id}`}
                size={200}
                includeMargin={true}
                className="border border-gold p-2 bg-black rounded-lg"
              />

              <button
                onClick={() => handleDownloadQR(post.posting_id)}
                className="px-4 py-2 bg-gold text-black rounded-lg hover:bg-gold/85 transition"
              >
                Download QR
              </button>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence> */}
    </>
  );
};

export default React.memo(BlogCard);
